import { HttpResponse } from '@angular/common/http';

import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';
import { BiddingsDetailsPerPointDirectionViewModel } from './types/biddingsDetailsPerPointDirectionViewModel';
import { BiddingsOverviewPerPointDirectionViewModel } from './types/biddingsOverviewPerPointDirectionViewModel';
import { BiddingsPerPointDirectionViewModel } from './types/biddingsPerPointDirectionViewModel';
import { BiddingsStatusViewModel } from './types/biddingsStatusViewModel';
import { BiddingsStrategiesOfContractViewModel } from './types/biddingsStrategiesOfContractViewModel';
import { BiddingsStrategiesViewModel } from './types/biddingsStrategiesViewModel';
import { CreateBiddingsStrategyRequest } from './types/createBiddingsStrategyRequest';
import { SendBidsToMadaRequest } from './types/sendBidsToMadaRequest';
import { UpdateBiddingsStrategyRequest } from './types/updateBiddingsStrategyRequest';

/**
 * @internal
 */
export class ApiMidbackBidding extends ApiBaseMidBack {
  sendBids(body: SendBidsToMadaRequest[]) {
    return this.post('/biddings/send-bids', new DefaultParams(body));
  }

  getBiddings(params: ParamsAdapter) {
    return this.get<BiddingsPerPointDirectionViewModel[]>('/biddings', params);
  }

  getBiddingDetails(params: ParamsAdapter) {
    return this.get<BiddingsDetailsPerPointDirectionViewModel[]>('/biddings/details', params);
  }

  getBiddingOverview(params: ParamsAdapter) {
    return this.get<BiddingsOverviewPerPointDirectionViewModel[]>('/biddings/overview', params);
  }

  @ApiOptions({ interceptErrors: false, responseType: 'blob', responseObserve: 'response' })
  exportBiddingOverview(params: ParamsAdapter) {
    return this.get<HttpResponse<Blob>>('/biddings/overview/excel', params);
  }

  getStatuses(params: ParamsAdapter) {
    return this.get<BiddingsStatusViewModel>('/biddings/get-biddings-status-of-contract', params);
  }

  @ApiOptions({ interceptErrors: false })
  getBiddingStrategy(contractId: number) {
    return this.get<BiddingsStrategiesOfContractViewModel>(`/biddings/strategies-of-contract/${contractId}`);
  }

  @ApiOptions({ interceptErrors: false })
  createBiddingStrategy(body: CreateBiddingsStrategyRequest) {
    return this.post<BiddingsStrategiesViewModel>(`/biddings/strategy`, new DefaultParams(body));
  }

  @ApiOptions({ interceptErrors: false })
  updateBiddingStrategy(body: UpdateBiddingsStrategyRequest) {
    return this.patch<BiddingsStrategiesViewModel>(`/biddings/strategy`, new DefaultParams(body));
  }
}
